<template>
    <span class="navigation-toggler-wrapper hide-for-medium" :class="{ expanded: expanded }">
        <a :href="telHref" v-html="telHtml" class="phone-trigger" v-if="tel"></a>
        <span
                class="navigation-toggler"
                :class="{ only: !tel }"
                @click="toggle"
        >
            <i class="fas fa-bars"></i>
        </span>
    </span>
</template>
<script>
    export default {
        props: {
            tel: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                expanded: false
            }
        },
        computed: {
            telHref() {
                return 'tel:' + this.tel.replace(' ', '');
            },
            telHtml() {
                return '<i class="fas fa-phone fa-fw"></i> ' + this.tel;
            }
        },
        created() {
            window.EventHandler.listen('navigation-toggled', visible => this.expanded = visible);
        },
        methods: {
            toggle() {
                window.EventHandler.fire('toggle-navigation');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/src/components/Navigation/Toggler.vue